import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PersonalRoutingModule } from './personal-routing.module';
import { EmployeeQualificationComponent } from './employee-qualification/employee-qualification.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ManageEmployeeQualificationComponent } from './manage-employee-qualification/manage-employee-qualification.component';
import { QualificationApproverComponent } from './qualification-approver/qualification-approver.component';
import { ExperienceCrudComponent } from './experience/experience-crud/experience-crud.component';
import { ExperienceListComponent } from './experience/experience-list/experience-list.component';
import { ExperienceViewComponent } from './experience/experience-view/experience-view.component';


@NgModule({
  declarations: [
    EmployeeQualificationComponent,
    ManageEmployeeQualificationComponent,
    QualificationApproverComponent,
    ExperienceCrudComponent,
    ExperienceListComponent,
    ExperienceViewComponent,
  ],
  imports: [
    CommonModule,
    PersonalRoutingModule,
    SharedModule
  ]
})
export class PersonalModule { }
